import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StoreModule, Store } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CalendarModule, CalendarDateFormatter, CalendarUtils } from 'angular-calendar';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskModule } from 'ngx-mask';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InternationalPhoneModule, IntPhonePrefixComponent } from 'ng4-intl-phone';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import {
  MatDialogModule,
  MatSliderModule,
  MatDatepickerModule,
  MatProgressBarModule,
  MatFormFieldModule
} from '@angular/material';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ProgressBarModule } from 'primeng/progressbar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ButtonModule } from 'primeng/button';
import { environment } from '../environments/environment';
// Routing
import { RoutingConfig } from './app.routes';

// Services
import { BusService } from './services/bus.service';
import { RequestService } from './services/request.service';
import { EventsService } from './services/events.service';

// Interceptors
import { HeadersInterceptor } from './interceptors/interceptors.header';
import { EmptyResponseBodyErrorInterceptor } from './interceptors/interceptors.empty';
import { LoggingInterceptor } from './interceptors/interceptors.logging';

// Components
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { ClinicComponent } from './components/clinic/clinic.component';
import { TreatmentComponent } from './components/treatment/treatment.component';
import { PractitionerComponent } from './components/practitioner/practitioner.component';
import { DateComponent } from './components/date/date.component';
import { TimeComponent } from './components/time/time.component';
import { DetailsComponent } from './components/details/details.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { PaymentComponent } from './components/payment/payment.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { CabinetComponent } from './components/cabinet/cabinet.component';
import { ConfirmedComponent } from './components/confirmed/confirmed.component';
import { ModalComponent } from './components/popups/modal/modal.component';
import { ErrorComponent } from './components/popups/error/error.component';
import { PasswordCreateComponent } from './components/password-create/password-create.component';
import { AppointmentComponent } from './components/appointment/appointment.component';

// Reducers
import { Reducers } from './reducers/index';

// Effects
import { LoginEffect } from './effects/login.effect';
import { LogoutEffect } from './effects/logout.effect';
import { BookingEffect } from './effects/booking.effect';
import { DataEffect } from './effects/data.effect';
import { RegistrationEffect } from './effects/registration.effect';
import { InfoEffect } from './effects/info.effect';
import { AppointmentEffect } from './effects/appointment.effect';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ClinicComponent,
    TreatmentComponent,
    PractitionerComponent,
    DateComponent,
    TimeComponent,
    DetailsComponent,
    ConfirmationComponent,
    PaymentComponent,
    HomeComponent,
    HeaderComponent,
    ModalComponent,
    CabinetComponent,
    ConfirmedComponent,
    ErrorComponent,
    PasswordCreateComponent,
    AppointmentComponent
  ],
  imports: [
    // AccordionModule,
    FormsModule,
    BrowserModule,
    HttpClientModule,
    RoutingConfig,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    StoreModule.forRoot(Reducers),
    EffectsModule.forRoot([
      LoginEffect,
      LogoutEffect,
      BookingEffect,
      DataEffect,
      RegistrationEffect,
      InfoEffect,
      AppointmentEffect]),
    // StoreDevtoolsModule.instrument({ maxAge: 10 }),
    StoreDevtoolsModule.instrument({
      // Restrict extension to log-only mode
      logOnly: environment.production
    }),
    InternationalPhoneModule,
    CalendarModule.forRoot(),
    NgbModalModule.forRoot(),
    TextMaskModule,
    NgxMaskModule.forRoot(),
    CreditCardDirectivesModule,
    MatDialogModule,
    MatSliderModule,
    MatDatepickerModule,
    MatProgressBarModule,
    ProgressBarModule,
    ScrollPanelModule,
    ButtonModule,
    MatSnackBarModule,
    MatFormFieldModule
  ],

  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

  providers: [
    Store,
    CalendarDateFormatter,
    CalendarUtils,

    // Services
    BusService,
    EventsService,
    RequestService,

    // Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EmptyResponseBodyErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoggingInterceptor,
      multi: true
    }
  ],
  entryComponents: [ErrorComponent, ModalComponent, DetailsComponent, IntPhonePrefixComponent],
  bootstrap: [AppComponent]
})

export class AppModule {}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/app.module.ts